<div class="container">

    <h2>Move Session Data</h2>
    <small>Select the session you want to move data from and the session you want to move data to. <br>
        This will copy any recorded data from the source session to the destination session. The source session will not be deleted, it will stay empty and with an added explanation about the moving of the data. <br>
        This operation can´t be undone.<br>
    </small>

    <div class="row">
        <div class="col-12 mt-4">
                    <label for="sourceSession" class="form-label">Source Session (data will be copied from)</label>
                    <p-dropdown id="sourceSession" 
                        [style]="{'width': '100%'}"
                        [styleClass]="'w-100'"
                        [options]="sourceSessions" 
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Source Session" 
                        [filter]="true" 
                        filterBy="SessionName" 
                        [showClear]="true"
                        [(ngModel)]="sessionDataToMove.SessionIDSource"
                        [disabled]="loading">
                        <ng-template pTemplate="selectedSession" let-selectedOption>
                          <div class="flex align-items-center gap-2">
                            <div class="d-flex flex-column">
                              {{ getSessionName(selectedOption.value) }}
                            </div>
                          </div>
                        </ng-template>
                    </p-dropdown>
        @if (sessionDataToMove.SessionIDSource) {
            <div class="mt-3">
                <h5>Data that will be moved:</h5>
                <div class="rounded p-3 mb-3" style="background-color: white; max-height: 200px; overflow-y: auto;">
                    <div style="color: #1C355E;">
                        @if (getTargetDataCount(sessionDataToMove.SessionIDSource) > 0) {
                            <div class="mb-3">
                                <h6>Target Data ({{getTargetDataCount(sessionDataToMove.SessionIDSource)}} records):</h6>
                                @for (targetData of targetDatasFromSessionID(sessionDataToMove.SessionIDSource); track targetData.ID) {
                                    <div class="ms-3">
                                        • {{getTargetData(targetData.PatientTargetID!)}}
                                    </div>
                                }
                            </div>
                        }
                        @if (getBehaviorDataCount(sessionDataToMove.SessionIDSource) > 0) {
                            <div class="mb-3">
                                <h6>Behavior Data ({{getBehaviorDataCount(sessionDataToMove.SessionIDSource)}} records):</h6>
                                @for (behaviorData of behaviorDatasFromSessionID(sessionDataToMove.SessionIDSource); track behaviorData.ID) {
                                    <div class="ms-3">
                                        • {{getBehaviorData(behaviorData.PatientBehaviorID!)}}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                <small class="text-muted">
                    Total target data to be moved: {{getTargetDataCount(sessionDataToMove.SessionIDSource)}}
                    <br>
                    Total behavior data to be moved: {{getBehaviorDataCount(sessionDataToMove.SessionIDSource)}}
                </small>
            </div>
        }
        </div>

        <div class="col-12 mt-4">
                <label for="destinationSession" class="form-label">Destination Session (data will be copied to)</label>
                <p-dropdown id="destinationSession" 
                            [style]="{'width': '100%'}"
                            [styleClass]="'w-100'"
                            [options]="destinationSessions" 
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Destination Session" 
                            [filter]="true" 
                            filterBy="SessionName" 
                            [showClear]="true"
                            [(ngModel)]="sessionDataToMove.SessionIDDestination"
                            [disabled]="loading">
                            <ng-template pTemplate="selectedSession" let-selectedOption>
                                <div class="flex align-items-center gap-2">
                                    <div class="d-flex flex-column">
                                        {{ getSessionName(selectedOption.value) }}
                                    </div>
                                </div>
                            </ng-template>
                </p-dropdown>
                @if (sessionDataToMove.SessionIDDestination) {
                    <div class="mt-3">
                        <h5>Data already on the session that will receive the data:</h5>
                        <div class="rounded p-3 mb-3" style="background-color: white; max-height: 200px; overflow-y: auto;">
                            <div style="color: #1C355E;">
                                @if (getTargetDataCount(sessionDataToMove.SessionIDDestination) > 0) {
                                    <div class="mb-3">
                                        <h6>Target Data ({{getTargetDataCount(sessionDataToMove.SessionIDDestination)}} records):</h6>
                                        @for (targetData of targetDatasFromSessionID(sessionDataToMove.SessionIDDestination); track targetData.ID) {
                                            <div class="ms-3">
                                                • {{getTargetData(targetData.PatientTargetID!)}}
                                            </div>
                                        }
                                    </div>
                                }
                                @if (getBehaviorDataCount(sessionDataToMove.SessionIDDestination) > 0) {
                                    <div class="mb-3">
                                        <h6>Behavior Data ({{getBehaviorDataCount(sessionDataToMove.SessionIDDestination)}} records):</h6>
                                        @for (behaviorData of behaviorDatasFromSessionID(sessionDataToMove.SessionIDDestination); track behaviorData.ID) {
                                            <div class="ms-3">
                                                • {{getBehaviorData(behaviorData.PatientBehaviorID!)}}
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
        </div>

        <div class="col-12 mt-4">
            <button class="btn btn-primary w-100" 
                    [disabled]="!sessionDataToMove.SessionIDSource || !sessionDataToMove.SessionIDDestination || loading"
                    (click)="moveSessionData()">
            Move Session Data
            </button>
        </div>
    </div>

    <div class="row mb-5">

    </div>
</div>

<app-loading-indicator *ngIf="loading"></app-loading-indicator>
